module.exports = {
  "id": "3eda88c0-1038-48f0-91aa-b7118e92b6b7",
  "gtmIds": [
    "GTM-T6PH9B8B",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.moreysresorts.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}